import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { ConsumerApplicationState, ConsumerApplication, ConsumerApplicationStatus, ConsumerApplicationResponse } from './types';
import { RootState } from '../types';

export const state: ConsumerApplicationState = {
    isLoaded: false,
    consumerApplication: {} as ConsumerApplication,
    consumerApplicationResponse: {} as ConsumerApplicationResponse,
    error: false,
    isValidApplicationForm: false,
    processingStatus: ConsumerApplicationStatus.NONE
};

const namespaced = true;

export const consumerApplication: Module<ConsumerApplicationState, RootState> = {
    namespaced,
    state,
    getters,
    actions,
    mutations
};
